import { render, staticRenderFns } from "./inventoryList.vue?vue&type=template&id=3ed54206&scoped=true"
import script from "./inventoryList.vue?vue&type=script&lang=js"
export * from "./inventoryList.vue?vue&type=script&lang=js"
import style0 from "./inventoryList.vue?vue&type=style&index=0&id=3ed54206&prod&scoped=true&lang=css"
import style1 from "./inventoryList.vue?vue&type=style&index=1&id=3ed54206&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed54206",
  null
  
)

export default component.exports